import { SchedulablePresenter } from 'shared/presenters/SchedulablePresenter'
import { TimeSlotBookingPresenter } from 'shared/presenters/TimeSlotBookingPresenter'
import dayjs, { Dayjs } from 'dayjs'
import { determineOptionalExtrasInitialValues } from 'helpers/determineOptionalExtrasInitialValues'
import { OptionalExtraQuantity } from 'shared/enums/schedulables'
import { QUERY_STRING_DAYJS_FORMAT } from 'enums/date'
import customParseFormat from 'dayjs/plugin/customParseFormat'
import utc from 'dayjs/plugin/utc'
import { ResourceRequirementQuantities } from 'shared/types'

dayjs.extend(customParseFormat)
dayjs.extend(utc)

export interface AddABookingValues extends OptionalExtraQuantity {
  adultsGoing: number
  childrenGoing: number
  timeSlot: TimeSlotBookingPresenter
  calendarSelection?: Dayjs
  organizerParticipating?: string
  desiredResourceRequirements?: ResourceRequirementQuantities
  exclusive?: boolean
  visibleTimeSlots: number
  isGift: boolean
}

/**
 * An empty presenter object used for comparison
 */
export const defaultTimeSlot = new TimeSlotBookingPresenter({})

type preSelectedDate = string

/**
 * For determining initial values to apply to the schedulable form indexed
 * in consumer/pages/outlets/[outletSlug]/activities/[activitySlug]/index.tsx
 *
 * This will be driven by backend data and previous selections taken from global
 * state
 */
const generateInitialValuesForActivity = (
  activity: SchedulablePresenter,
  preSelectedDate?: preSelectedDate
): AddABookingValues => {
  const optionalExtra = determineOptionalExtrasInitialValues(activity)

  const calendarSelection = determineCalendarPreselection(preSelectedDate)

  return {
    isGift: false,
    adultsGoing: 0,
    childrenGoing: 0,
    timeSlot: new TimeSlotBookingPresenter({}),
    exclusive: false,
    visibleTimeSlots: 5,
    optionalExtra,
    calendarSelection
  }
}

export default generateInitialValuesForActivity

const determineCalendarPreselection = (preSelectedDate?: preSelectedDate) => {
  return preSelectedDate
    ? dayjs.utc(preSelectedDate, QUERY_STRING_DAYJS_FORMAT)
    : undefined
}
